import React, {Component} from 'react'
import {Typeahead} from 'react-bootstrap-typeahead-ali/dist/react-bootstrap-typeahead'
import {Actions} from 'jumpstate'

class Colors extends Component {
  constructor (props) {
    super(props)
    this.state = {
      term: '',
      options: [],
      message: props.defaultColor,
      color: {
        id: null,
        name: '',
        key: ''
      }
    }
    this.timeout = null
    this.seek = this.seek.bind(this)
    this.pickOption = this.pickOption.bind(this)
    this.changeKeyword = this.changeKeyword.bind(this)
  }

  seek (keyword) {
    Actions.colorSeek(keyword).then((res) => {
      if (res.data.length === 0) {
        this.setState({options: [], message: 'موردی یافت نشد'})
      } else {
        this.setState({options: res.data, message: ''})
      }
    })
  }

  pickOption (picked) {
    if (picked.length === 0) { return Actions.setNewHorseDetails({color_id: undefined}) }
    this.setState({color: picked[0]})
    Actions.setNewHorseDetails({color_id: picked[0].id, color: picked[0]})
    Actions.validateNewHorseData()
  }

  changeKeyword (keyword) {
    this.setState({message: keyword, term: keyword})
    Actions.addNewHorseTouched('color_id')
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (keyword.length > 0) {
      this.timeout = setTimeout(() => this.seek(keyword), 700)
    } else {
      this.setState({message: '', options: []})
    }
  }

  render () {
    const {options, message, term} = this.state
    const {placeholder, errors} = this.props

    return (
      <Typeahead
        onChange={this.pickOption}
        onInputChange={this.changeKeyword}
        emptyLabel={message}
        value={term}
        placeholder={placeholder}
        className={`Name ${errors ? 'form-component-error' : ''}`}
        labelKey="name"
        options={options}
        onBlur={() => { setTimeout(() => { Actions.addNewHorseTouched('color_id'); Actions.validateNewHorseData() }, 1500) }}
      />
    )
  }
}

Colors.propTypes = {
  defaultColor: React.PropTypes.string,
  placeholder: React.PropTypes.string.isRequired,
  errors: React.PropTypes.string
}

export default Colors



// WEBPACK FOOTER //
// ./src/components/NewHorse/Colors/Colors.js